import user from './user'
import info from './info'
import comment from './comment'
import personal from './personal'
import home from './home'

export default [user, info, comment, personal, home]
